import { Injectable } from '@angular/core';
import { GetResellersResult, Dealer, WishListItem, CustomerInfo, SendWishListToDealerResult, SendWishListResult, FilterType } from '../models';
import { TestResellersResult, TestSendWishListToDealerResult, TestSendWishListResult } from './mock-backend';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mapTo';
import { map } from 'rxjs/operators';

@Injectable()
export class BackendService {

    getRandomSeed(): string {
        return (Math.random() * 10000000000).toFixed(0);
    }
    constructor(private http: HttpClient) {
        //
    }

    public GetResellers(address: string, filter: FilterType, captcha: string = null): Observable<GetResellersResult> {

        // return Observable.of(new Object()).mapTo(TestResellersResult);

        let params = new HttpParams().set('address', address).set('filter', filter.toFixed(0));

        if (captcha != null) { params = params.set('captcha', captcha); }
        // debugger;
        return this.http.get<GetResellersResult>(environment.getResellersUrl + '?_=' + this.getRandomSeed() , {
            params: params
        });

        // return TestResellersResult;
    }

    public SendWishListToDealer(customer: CustomerInfo, dealer: Dealer, wishList: WishListItem[], challenge: string):
        Observable<SendWishListToDealerResult> {

        // debugger;
        return this.http.post<SendWishListToDealerResult>(environment.sendWishListToDealerUrl, {
            customerInfo: customer,
            dealerName: dealer.name,
            wishList: wishList,
            challenge: challenge
        });

        // return Observable.of(new Object()).mapTo(TestSendWishListToDealerResult);
    }

    public SendWishList(customer: CustomerInfo, wishList: WishListItem[], challenge: string): Observable<SendWishListResult> {
        return Observable.of(new Object()).mapTo(TestSendWishListResult);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/backend.service.ts